function startOfDay(d: Date): Date {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

export function isDayPast(day: string, now: Date = new Date()): boolean {
  const [y, m, d] = day.split('-').map(Number);
  if (!y || !m || !d) return false;
  const dayStart = new Date(y, m - 1, d);
  return startOfDay(dayStart) < startOfDay(now);
}

export function isSlotPast(day: string, hour: number, now: Date = new Date()): boolean {
  if (isDayPast(day, now)) return true;
  const [y, m, d] = day.split('-').map(Number);
  if (!y || !m || !d) return false;
  const dayStart = new Date(y, m - 1, d);
  if (startOfDay(dayStart) > startOfDay(now)) return false;
  return hour < now.getHours();
}

export function isYearFullyPast(year: number, now: Date = new Date()): boolean {
  return year < now.getFullYear();
}

export function isMonthFullyPast(viewDate: Date, now: Date = new Date()): boolean {
  const y = viewDate.getFullYear();
  const m = viewDate.getMonth();
  const lastDay = new Date(y, m + 1, 0);
  return startOfDay(lastDay) < startOfDay(now);
}

export function isWeekFullyPast(weekStart: Date, weekDays: number, now: Date = new Date()): boolean {
  const end = new Date(weekStart);
  end.setDate(end.getDate() + weekDays - 1);
  return startOfDay(end) < startOfDay(now);
}

export function isDayFullyPast(day: string, now: Date = new Date()): boolean {
  return isDayPast(day, now);
}

export type CalendarZoomLevel = 0 | 1 | 2 | 3;

export function isViewRangeFullyPast(
  level: CalendarZoomLevel,
  viewDate: Date,
  weekStartDate: Date,
  weekStep: number,
  dayDateStr: string,
  now: Date = new Date()
): boolean {
  switch (level) {
    case 0:
      return isYearFullyPast(viewDate.getFullYear(), now);
    case 1:
      return isMonthFullyPast(viewDate, now);
    case 2:
      return isWeekFullyPast(weekStartDate, weekStep, now);
    case 3:
      return isDayFullyPast(dayDateStr, now);
    default:
      return false;
  }
}
